

export default function extractCostParts(costString) {
  const parts = costString ?
  costString.match(/^([a-zA-Z]*)\s*([^\d\s]*)\s*(\d+)$/) || [] :
  [];

  return {
    currency: parts[1],
    currencySymbol: parts[2],
    cost: parseInt(parts[3], 10)
  };
}